<div
  class="notification display-flex grid-gap-10"
  [ngClass]="{ warning: type === 'warning', info: type === 'info', error: type === 'error' }">
  <div class="notification__icon" *ngIf="icon">
    <app-icon [svg]="icon" [iconHeight]="20" [iconWidth]="20" [iconColor]="iconColor"></app-icon>
  </div>

  <div class="display-flex align-items-center grid-gap-16 content-warning" *ngIf="!icon">
    <div class="display-flex flex-column align-items-center justify-content-center grid-gap-2 content-warning-icon">
      <div class="content-warning-icon-dot"></div>
      <div class="content-warning-icon-line"></div>
    </div>
  </div>

  <div class="notification__text">
    <ng-content></ng-content>
  </div>
</div>
